"use strict";

import "./Input.css";
import React from "react";
import classnames from "classnames";
import TypingListener from "./../../TypingListener";

export default class Input extends React.Component {
	
	componentDidMount() {
		if (this.props.onTypeEnd) {
			this.typingListener = new TypingListener(this.refs.input, this.props.typingTimeout, value => this.props.onTypeEnd(value));
		}
	}
	
	getInputProps() {
		let inputProps = {};
		for (let key in this.props) {
			if (key == "ref")
				continue;
			inputProps[key] = this.props[key];
		}
		return inputProps;
	}
	
	render() {
		
		const type = /^(text|password|number)$/.test(this.props.type) ? this.props.type : "text";
		
		return (
			<input
				ref="input"
				{...this.getInputProps()}
				type={type}
				className={classnames(this.props.className, "Input")}
			/>
		);
	}
	
}

Input.propTypes = {
	typingTimeout: React.PropTypes.number,
	onTypeEnd: React.PropTypes.func
};

Input.defaultProps = {
	typingTimeout: 1000
};


// WEBPACK FOOTER //
// ./~/vwa/components/Input/Input.jsx